export const TEST_ID_TOGGLE_MUTE = 'Toggle mute'
export const TEST_ID_TOGGLE_VIDEO = 'Toggle video'
export const TEST_ID_READING_CARD = 'ReadingCard'
export const TEST_ID_READING_ACTION_BUTTON = 'TEST_ID_READING_ACTION_BUTTON'
export const TEST_ID_READING_CAROUSEL = 'ReadingCarousel'
export const TEST_ID_READING_FILTERS = 'ReadingFilters'
export const TEST_ID_READING_CARD_GRID = 'READING_CARD_GRID'
export const TEST_ID_FEEDBACK = 'Feedback'
